import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

// Generate or get session ID
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('analytics_session_id');
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem('analytics_session_id', sessionId);
  }
  return sessionId;
};

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const trackPageView = async () => {
      try {
        await fetch(`${API_URL}/api/track/pageview`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            page: location.pathname,
            referrer: document.referrer,
            user_agent: navigator.userAgent,
            session_id: getSessionId()
          })
        });
      } catch (e) {
        // Silently fail - don't block user experience
        console.log('Page tracking failed');
      }
    };

    trackPageView();
  }, [location.pathname]);
};

// Track custom events (button clicks, form submissions, etc.)
export const trackEvent = async (eventName, eventType = 'click', metadata = {}) => {
  try {
    await fetch(`${API_URL}/api/track/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event_name: eventName,
        event_type: eventType,
        page: window.location.pathname,
        metadata,
        session_id: getSessionId()
      })
    });
  } catch (e) {
    console.log('Event tracking failed');
  }
};

export default usePageTracking;
